<template>
    <div class="club" :class="[{ loading }]" @click="$emit('click')">
        <div v-if="loading" class="loading-skeleton">
            <SvgLoader path="assets/img/skeletons/event-skeleton" />
        </div>
        <div v-else class="main-content">
            <div class="col club-title-container">
                <div
                    v-if="data.user && data.user.instagram"
                    class="club-image"
                    :style="`background-image: url(${data.user.instagram.igProfilePic});`"
                ></div>
                <div
                    v-else
                    class="club-image"
                    :style="`background-image: url(https://www.pngkit.com/png/detail/353-3536328_generic-placeholder-image-question-and-answer-signs.png);`"
                ></div>
                <div class="text-container">
                    <div v-if="data.user && data.user.instagram" class="title copy-l bold" :title="data.user">
                        {{ data.firstName }} {{ data.lastName }} ({{ data.user.instagram.igFullName }})
                        <span v-if="data.dates && data.dates < 5">(+{{ data.dates }})</span>
                        <span v-if="data.dates && data.dates > 5">(>5)</span>
                    </div>
                    <div
                        v-else-if="data.firstName || data.lastName"
                        class="title copy-l bold"
                        :title="data.firstName + ' ' + data.lastName"
                    >
                        {{ data.firstName }} {{ data.lastName }}
                        <span v-if="data.dates && data.dates < 5">(+{{ data.dates }})</span>
                        <span v-if="data.dates && data.dates > 5">(>5)</span>
                        <span v-if="data.maximumDates">(max. {{ data.maximumDates }})</span>
                    </div>
                    <div v-else-if="data.email" class="title copy-l bold" :title="data.email">
                        {{ data.email }} <span v-if="data.dates && data.dates < 5">(+{{ data.dates }})</span>
                        <span v-if="data.dates && data.dates > 5">(>5)</span>
                        <span v-if="data.maximumDates">(max. {{ data.maximumDates }})</span>
                    </div>
                    <div v-else-if="data.phone" class="title copy-l bold" :title="data.phone">
                        {{ data.phone }} <span v-if="data.dates && data.dates < 5">(+{{ data.dates }})</span>
                        <span v-if="data.dates && data.dates > 5">(>5)</span>
                        <span v-if="data.maximumDates">(max. {{ data.maximumDates }})</span>
                    </div>
                    <div v-else-if="data.user" class="title copy-l bold" :title="data.user">
                        User {{ data.user.id }} <span v-if="data.dates && data.dates < 5">(+{{ data.dates }})</span>
                        <span v-if="data.dates && data.dates > 5">(>5)</span>
                        <span v-if="data.maximumDates">(max. {{ data.maximumDates }})</span>
                    </div>
                    <div v-else class="title copy-l bold" :title="data.user">
                        Guest {{ data.id }} <span v-if="data.dates && data.dates < 5">(+{{ data.dates }})</span>
                        <span v-if="data.dates && data.dates > 5">(>5)</span>
                        <span v-if="data.maximumDates">(max. {{ data.maximumDates }})</span>
                    </div>
                    <div class="description">
                        <div class="text copy-m">
                            <div class="fans">{{ data.status }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="data.status === 'Attending'" class="attend-container">
                <Approve :attending="true" @click="$emit('decline', data)" />
            </div>
            <div v-else-if="data.status === 'Approved'" class="approve-container">
                <Approve :approved="true" @click="$emit('attend', data)" />
            </div>
            <div v-else-if="data.status === 'Invited'" class="invited-container">
                <Approve :invited="true" @click="$emit('attend', data)" />
            </div>
            <div v-else class="status-container">
                <Approve @click="$emit('approve', data)" />
            </div>
            <div class="more-container">
                <DContextMenu>
                    <DContextMenuItem
                        :label="'Attending'"
                        type="default"
                        @click="$emit('attending', data, 'Attending')"
                    />
                    <DContextMenuItem :label="'Approved'" type="default" @click="$emit('approved', data, 'Approved')" />
                    <DContextMenuItem
                        :label="'Requested'"
                        type="default"
                        @click="$emit('requested', data, 'Requested')"
                    />
                    <DContextMenuItem
                        :label="'Declined'"
                        type="default"
                        @click="$emit('declined', data, 'HostDeclined')"
                    />
                    <DContextMenuItem :label="'Invited'" type="default" @click="$emit('invited', data, 'Invited')" />
                </DContextMenu>
            </div>
        </div>
    </div>
</template>

<script>
import SvgLoader from '@/components/SvgLoader'
import Approve from '@/components/Approve'
import DContextMenu from '@/components/DContextMenu'
import DContextMenuItem from '@/components/DContextMenuItem'

export default {
    name: 'GuestRow',
    components: {
        Approve,
        SvgLoader,
        DContextMenu,
        DContextMenuItem,
    },
    props: {
        data: {
            type: Object,
            default: undefined,
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
}
</script>

<style scoped lang="sass">
.guest
.club
    position: relative
    padding: $m $l
    border-radius: 1rem
    cursor: pointer
    margin-left: -$m
    @include breakpoint('l')
        display: flex
        box-sizing: border-box
        overflow: hidden
        margin-left: 0

        .main-content
            flex-direction: row
            align-items: space-between

    .main-content
        display: flex
        align-items: center
        flex-grow: 1

    .status-container, .more-container, .approve-container, .invited-container
        background: $gray-1
        &:hover
            background: darken($gray-1, 5%)

    .attend-container
        background: $primary-1
        &:hover
            background: lighten($primary-1, 5%)

    .attend-container, .approve-container, .more-container, .status-container, .invited-container
        width: 3rem
        height: 3rem
        display: flex
        z-index: 5
        position: relative
        align-items: center
        justify-content: center
        border-radius: 99em
        margin-left: $m
        transform: scale(0.8)
        +transition(80ms)

        .feather-icon
            width: 1.8rem

    .approve-container, .status-container, .attend-container, .invited-container
        z-index: 1 !important

    &:hover
        background: white
        box-shadow: $box-mois

    .approve-container, .attend-container, .more-container, .status-container, .invited-container
        transform: scale(1)
        opacity: 1

    .col
        flex: 1

        &.club
            &-genres
                white-space: nowrap
                overflow: hidden
                text-overflow: ellipsis
                color: transparent

                .tag
                    display: inline-flex

            &-title-container
                display: flex
                min-width: 350px
                .text-container
                    .title
                        white-space: nowrap
                        max-width: 250px
                        text-overflow: ellipsis
                        overflow: hidden
                        padding-right: $l

                    .time
                        color: $neutral-2

                .club-image
                    width: 4.8rem
                    min-width: 4.8rem
                    height: 4.8rem
                    background: $gray-1
                        size: cover
                        position: center
                    border-radius: 99rem
                    margin-right: $l


            &-rsvp
                display: flex
                align-items: center
                justify-content: flex-end

                .rsvp-container
                    display: flex
                    align-items: center
                    justify-content: flex-end
                    transform: translate(40px, 0)
                    +transition(80ms)

                    .text
                        white-space: nowrap
                        text-align: right

                    .feather-icon.user-icon
                        width: 16px
                        margin-right: $xs
</style>
